import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';

import { V2CardComponent } from '../card/v2-card.component';

@Component({
  selector: 'coin-v2-card-customer',
  standalone: true,
  imports: [],
  templateUrl: './v2-card-customer.component.html',
  styleUrls: ['../card/v2-card.component.scss', './v2-card-customer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class V2CardCustomerComponent extends V2CardComponent implements OnInit {
  contentPadding = input(true);

  ngOnInit(): void {
    this.rounding = 'medium';
    this.padding = 'none';
    this.shadow = 'large';
  }
}
